import { combineReducers } from "redux";
import userSlice from "./slices/userSlice.ts";
import authSlice from "./slices/authSlice.ts";
import colaboradoresSlice from "./slices/colaboradoresSlice.ts";
import listaNegraSlice from "./slices/listaNegraSlice.ts";
import catalogSlice from "./slices/catalogSlice.ts";
import solicitudesSlice from "./slices/solicitudesSlice.ts";
import puestosSlice from "./slices/puestosSlice.ts";
import sucursalesSlice from "./slices/sucursalesSlice.ts";
import vacantesSlice from "./slices/vacantesSlice.ts";
import tallasSlice from "./slices/tallasSlice.ts";
import periodicidadSlice from "./slices/periodicidadSlice.ts";
import turnosSlice from "./slices/turnosSlice.ts";
import branchTemplateSlice from "./slices/branchTemplateSlice.ts";
import traspasosSlice from "./slices/traspasosSlice.ts";
import colaboradoresBranchSlice from "./slices/colaboradoresBranchSlice.ts";
import entradasSlice from "./slices/entradasSlice.ts";
import chequeoSlice from "./slices/chequeoSlice.ts";
import inasistenciasSlice from "./slices/inasistenciasSlice.ts";
import notificationsUserSlice from "./slices/notificationsUserSlice.ts";
import adminNotificationsSlice from "./slices/adminNotificationsSlice.ts";
import reportSlice from "./slices/ReportsSlice.ts";
import badgesSlice from "./slices/badgesSlice.ts";
import incidentSlice from "./slices/incidentSlice.ts";
import scheduleSlice from "./slices/scheduleSlice.ts";
import duplicateDevicesSlice from "./slices/duplicateDevicesSlice.ts";
import reportClockSlice from "./slices/reportClockSlice.ts";
import payrollSlice from "./slices/payrollSlice.ts";
import incidenciaSlice from "./slices/incidenciaSlice.ts";
import permissionsSlice from "./slices/permissionsSlice.ts";
import missingBoxSlice from "./slices/missingBoxSlice.ts";
import loansSlice from "./slices/loansSlice.ts";
import holidaysSlice from "./slices/holidaysSlice.ts";
import holidayBalancesSlice from "./slices/holidayBalancesSlice.ts";
import incapacitiesSlice from "./slices/incapacitiesSlice.ts";
import directBossSlice from "./slices/directBossSlice.ts";
import complaintsSlice from "./slices/complaintsSlice.ts";
import documentTypeSlice from "./slices/documentTypeSlice.ts";

const rootReducer = combineReducers({
  auth: authSlice,
  user: userSlice,
  vacantes: vacantesSlice,
  colaboradores: colaboradoresSlice,
  listaNegra: listaNegraSlice,
  catalog: catalogSlice,
  solicitud: solicitudesSlice,
  puestos: puestosSlice,
  sucursales: sucursalesSlice,
  tallas: tallasSlice,
  periodicidad: periodicidadSlice,
  turnos: turnosSlice,
  branchTemplates: branchTemplateSlice,
  traspasos: traspasosSlice,
  colaboradoresBranch: colaboradoresBranchSlice,
  entradas: entradasSlice,
  chequeo: chequeoSlice,
  inasistencias: inasistenciasSlice,
  notificationUser: notificationsUserSlice,
  adminNotifications: adminNotificationsSlice,
  report: reportSlice,
  badges: badgesSlice,
  incident: incidentSlice,
  schedule: scheduleSlice,
  duplicateDevice: duplicateDevicesSlice,
  reportClock: reportClockSlice,
  payroll: payrollSlice,
  incidencias: incidenciaSlice,
  permissions: permissionsSlice,
  missingBox: missingBoxSlice,
  loans: loansSlice,
  holidays: holidaysSlice,
  holidayBalances: holidayBalancesSlice,
  incapacities: incapacitiesSlice,
  directBoss: directBossSlice,
  complaints: complaintsSlice,
  documentType: documentTypeSlice,
});

export default rootReducer;
